import { PopupCustom } from "@components/generals/popup";
import { Spiner } from "@components/loaders/spiner";
import { MadingApps } from "@services/dtos/home.dto";
import { HomeService } from "@services/home.service";
import { useThemeStore } from "@stores/theme.store";
import { useQuery } from "@tanstack/react-query";
import { linkPage } from "@utils/router";
import moment from "moment";
import { useEffect, useState } from "react";
import { BiFilter } from "react-icons/bi";
import { FaChevronDown } from "react-icons/fa";
import { FcFinePrint } from "react-icons/fc";
import { useLocation, useNavigate } from "react-router-dom";

export const NewsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [kategori, setkategori] = useState<string>("*");
  const [limit, setLimit] = useState<string>("10");
  const [popupFilter, setPopupFilter] = useState<boolean>(false);

  const { setFooter, setHeader, setAppBar } = useThemeStore((state) => state);

  const { data: dataMading, isLoading: isPendingMading } = useQuery({
    queryKey: [HomeService.queries.GET_MADING, kategori, limit],
    queryFn: () => HomeService.mading(kategori, limit),
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    setFooter(false);
    setHeader({
      type: "small",
      title: "Berita Terkini",
      buttonBack: true,
      avatar: false,
    });
    setAppBar({ leading: "back", title: "Berita Terkini" });
  }, [
    setFooter,
    setHeader,
    setAppBar,
    location.pathname,
    // limit,
  ]);

  const onOpenDetail = (news: MadingApps) => {
    navigate(linkPage.SCHOOL_NEWS_DETAIL, { state: news });
  };

  return (
    <>
      <div className="card card-style">
        <div className="content">
          <div className="d-flex justify-content-between align-items-center my-2">
            <p className="mb-0 tw-w-2/3 tw-text-black dark:tw-text-gray-300">
              Jumlah data yang ditampilkan: {limit} data terakhir
            </p>
            <button
              className="tw-text-white tw-bg-gray-700 hover:tw-bg-gray-600 tw-rounded-lg tw-p-2 tw-flex tw-items-center tw-justify-center tw-gap-2 tw-font-semibold"
              onClick={() => setPopupFilter(true)}
            >
              <BiFilter size={22} />
            </button>
          </div>
        </div>
      </div>
      {isPendingMading ? (
        <div
          className="card rounded-l mx-2 text-center shadow-l bg-theme d-flex"
          style={{ height: 289 }}
        >
          <Spiner className="!tw-text-gray-500 dark:!tw-text-gray-500 tw-w-8 tw-h-8 m-auto" />
        </div>
      ) : dataMading &&
        dataMading.data !== null &&
        dataMading.data.length > 0 ? (
        <div className="news-wrapper">
          {(dataMading?.data ?? [])
            .sort((a, b) => moment(b.tanggal).diff(moment(a.tanggal)))
            .map((mading, idx) => (
              <div
                className="ps-3 pe-3 mb-3"
                key={idx}
                onClick={() => onOpenDetail(mading)}
              >
                <div
                  className="card rounded-l mx-2 shadow-l"
                  style={{
                    height: 289,
                    backgroundImage: `url(${mading.gambar})`,
                  }}
                >
                  <div className="card-bottom">
                    <h1 className="!tw-text-left boxed-text-xl font-24 font-700 mb-0">
                      {mading.judul}
                    </h1>
                    <span className="!tw-text-left boxed-text-xl tw-text-xs mb-2">
                      {moment(mading.tanggal ?? Date.now()).format(
                        "dddd, DD MMMM YYYY"
                      )}
                    </span>
                    <p className="!tw-text-left boxed-text-xl mb-4 !tw-line-clamp-1">
                      {mading.pesan}
                    </p>
                  </div>
                  <div className="card-overlay bg-gradient-fade"></div>
                </div>
              </div>
            ))}
        </div>
      ) : (
        <div
          className="card rounded-l mx-3 text-center shadow-l bg-theme d-flex"
          style={{ height: 289 }}
        >
          <div className="tw-p-8 text-center" style={{ height: "100%" }}>
            <div className="d-grid" style={{ height: "100%" }}>
              <FcFinePrint size={50} className="my-auto mx-auto" />
              <div>Data tidak ditemukan</div>
            </div>
          </div>
        </div>
      )}

      <PopupCustom
        show={popupFilter}
        position="bottom"
        height={320}
        onCancel={() => setPopupFilter(false)}
      >
        <div className="pb-2 px-3">
          <h4 className="font-700 mt-3">Filter Data</h4>
          <div className="divider mt-3 mb-3"></div>
          <div className="input-style has-borders input-style-always-active no-icon mb-4">
            <label htmlFor="form5" className="color-highlight font-500">
              Jumlah ditampilkan
            </label>
            <select
              defaultValue="10"
              onChange={(e) => setLimit(e.target.value)}
              className="bg-theme"
            >
              <option value="default" disabled>
                Jumlah ditampilkan
              </option>
              <option value="10">10 Data Terakhir</option>
              <option value="20">20 Data Terakhir</option>
              <option value="50">50 Data Terakhir</option>
              <option value="100">100 Data Terakhir</option>
            </select>
            <span>
              <i>
                <FaChevronDown />
              </i>
            </span>
          </div>
          <div className="divider !tw-my-2" />
          <button
            className="btn btn-sm btn-full rounded-xs text-uppercase font-900 shadow-s bg-red-dark tw-grow my-3 tw-w-full tw-h-11"
            onClick={() => setPopupFilter(false)}
          >
            Tutup
          </button>
        </div>
      </PopupCustom>
    </>
  );
};
